import type { Config } from "mixpanel-browser";
import mixpanel from "mixpanel-browser";
import { IS_PRODUCTION, MIXPANEL_TOKEN } from "../../constants/env";
import {
  dropTrackingEventsOnAdminRoute,
  getRecordSessionsPercent,
  registerTrackingConsentSync,
} from "./session-replay/session-replay";

export const MIX_PANEL_PERSISTENCE_NAME = "mixpanel";
const PERSISTENCE = "localStorage";
const TRACK_PAGEVIEW = "full-url";
const EU_API_HOST = "https://api-eu.mixpanel.com";
const UNMASKED_INPUT_SELECTOR = "[data-mp-unmask]";

const mixPanelConfig: Partial<Config> = {
  api_host: EU_API_HOST,
  persistence: PERSISTENCE,
  debug: !IS_PRODUCTION,
  track_pageview: TRACK_PAGEVIEW,
  persistence_name: MIX_PANEL_PERSISTENCE_NAME,
  opt_out_tracking_by_default: true,
  record_sessions_percent: getRecordSessionsPercent(),
  record_mask_all_text: false,
  record_mask_all_inputs: true,
  record_unmask_input_selector: UNMASKED_INPUT_SELECTOR,
  record_heatmap_data: true,
  hooks: {
    before_send_events: dropTrackingEventsOnAdminRoute,
  },
};

mixpanel.init(MIXPANEL_TOKEN, mixPanelConfig);
registerTrackingConsentSync();

export default mixpanel;
